import { Component, Input, OnInit } from '@angular/core';
import { PortfolioService } from '../portfolio.service';
import { Portfolio } from '../portfolio';
import { NotificationService } from '../../shared/notification.service';
import { SelectComparisons } from '../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-portfolio-select',
  templateUrl: 'select.component.html',
})
export class PortfolioSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the portfolio to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the portfolios currently loaded.
   *
   * @type {Portfolio[]}
   */
  public portfolios: Portfolio[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {PortfolioService} portfolioService
   * @param {NotificationService} notificationService
   */
  constructor(
    private portfolioService: PortfolioService,
    private notificationService: NotificationService,
  ) {
    super();
    this.portfolioService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the portfolio list.
   */
  public ngOnInit(): void {
    this.loadPortfolios(1, 10000);
  }

  /**
   * Loads a list of portfolios using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadPortfolios(page?: number, limit?: number): void {
    const listPortfolios = this.portfolioService
      .listPortfolios(page, limit)
      .subscribe((portfolios: Portfolio[]) => {
        this.portfolios = portfolios;
        listPortfolios.unsubscribe();
      });
  }
}
